import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=bffbc3ba&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffbc3ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bffbc3ba')) {
      api.createRecord('bffbc3ba', component.options)
    } else {
      api.reload('bffbc3ba', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=bffbc3ba&scoped=true", function () {
      api.rerender('bffbc3ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/user/customerCSG/edit.vue"
export default component.exports